"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addGigRequirement = addGigRequirement;
const baseUrls_1 = require("./baseUrls");
const fetchWrapper_1 = require("./fetchWrapper");
async function addGigRequirement(gigCapabilityList, authToken, gigId) {
    try {
        const url = `${baseUrls_1.GigsApiBaseUrl}/addGigRequirement?gigId=${gigId}`;
        const response = await (0, fetchWrapper_1.fetchWrapper)(url, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            },
            body: gigCapabilityList,
        });
        if (response.ok) {
            const data = await response.json();
            return data;
        }
    }
    catch (e) {
        console.log(e);
    }
}
